module.exports = __webpack_public_path__ + "static/img/bg@2x.83227c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg@2x.png
// module id = j4yg
// module chunks = 1